<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Projet d'accueil des stagiaires">
        <p class="text-sm-left body-2 font-italic">
          Les informations à renseigner ne le sont qu’à titre indicatif et ne
          sauraient préjuger de l’avis qui sera émis par la commission régionale
          d’agrément.
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col>
              <span class="subtitle-1 text-left font-weight-bold">
                Y a-t-il des réunions d’échange ou de formation ?
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" />
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Au sein de l’officine
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.reunionOfficine"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="reunionOfficine"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="reunionOfficine"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="dossier.reunionOfficine">
            <v-col cols="1" />
            <v-col cols="12" md="6">
              <v-text-field
                v-model="dossier.reunionOfficineComplement"
                label="Si oui, combien en moyenne /mois ?"
                required
                :rules="textRules"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" />
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Interprofessionnelles
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.reunionInterprofessionnelle"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="reunionInterprofessionnelle"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="reunionInterprofessionnelle"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="dossier.reunionInterprofessionnelle">
            <v-col cols="1" />
            <v-col cols="12" md="6">
              <v-text-field
                v-model="dossier.reunionInterprofessionnelleComplement"
                label="Si oui, combien en moyenne /mois ?"
                required
                :rules="textRules"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" />
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Le stagiaire animera-t-il lui-même certaines réunions ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.reunionStagiairePresentation"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="reunionStagiairePresentation"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="reunionStagiairePresentation"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="5">
              <p class="subtitle-1 text-left">
                &#187; Y a-t-il des projets de développement des activités de
                l’officine ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.projetDeveloppement"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="projetDeveloppement"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="projetDeveloppement"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="dossier.projetDeveloppement">
            <v-col cols="1" />
            <v-col cols="12" md="6">
              <v-text-field
                v-model="dossier.projetDeveloppementComplement"
                label="Si oui, lesquels ?"
                required
                :rules="textRules"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Le stagiaire peut-il être impliqué dans le développement
                de ces nouvelles activités ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.stagiaireDeveloppement"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="stagiaireDeveloppement"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="stagiaireDeveloppement"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span class="subtitle-1 text-left font-weight-bold">
                Les activités quotidiennes du stagiaire sont-elles compatibles
                avec :
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" />
            <v-col cols="12" md="5">
              <p class="subtitle-1 text-left">
                &#187; La présence aux séances d'enseignement institutionnel
                (enseignement, séminaires …) ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.stagiairePresenceEnseignement"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="stagiairePresenceEnseignement"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="stagiairePresenceEnseignement"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" />
            <v-col cols="12" md="5">
              <p class="subtitle-1 text-left">
                &#187; La préparation d'une thèse d’exercice ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.theseExercice"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="theseExercice"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="theseExercice"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" />
            <v-col cols="12" md="5">
              <p class="subtitle-1 text-left">
                &#187; La participation à un travail d’évaluation des pratiques
                professionnelles ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.travailEvaluation"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="travailEvaluation"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="travailEvaluation"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" />
            <v-col cols="1">
              <v-btn
                color="blue"
                class="mr-4 white--text"
                @click="submit"
                :disabled="!valid"
                >Enregistrer et passer à l'étape suivante
                <v-icon>navigate_next</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import moment from "moment";

export default {
  name: "Partie15",
  props: ["dossier"],
  components: { BaseBlock },
  data: () => ({
    valid: true,
    menu: false,
    dateFormationEtp: null,
    textRules: [v => !!v || "Ce champ est requis"],
    radioRules: [v => v !== null || "Ce champ est requis"],
    numberRules: [
      v =>
        /^-?([0-9]\d*\.?\d*)$/.test(v) ||
        "La superficie doit être composée uniquement de chiffres"
    ]
  }),
  computed: {
    formatedDate() {
      return this.dateFormationEtp
        ? moment(this.dateFormationEtp).format("DD/MM/YYYY")
        : "";
    }
  },
  created() {
    if (this.dossier.dateFormationEtp) {
      let unix_timestamp = this.dossier.dateFormationEtp;
      var date = new Date(unix_timestamp);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      this.dateFormationEtp = year + "-" + month + "-" + day;
    }
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        if (!this.dossier.reunionOfficine)
          this.dossier.reunionOfficineComplement = null;
        if (!this.dossier.reunionInterprofessionnelle)
          this.dossier.reunionInterprofessionnelleComplement = null;
        if (!this.dossier.projetDeveloppement)
          this.dossier.projetDeveloppementComplement = null;

        this.dossier.dateFormationEtp = this.dateFormationEtp;
        this.$emit("save");
        this.$emit("nextPart");
      }
    }
  }
};
</script>
